module.exports = __webpack_public_path__ + "img/placeholder-portrait-notext.821bb7b0.png";